var WINDOW_LOAD_EVENT_NAME = "load";
var overwritten = false;
/**
 * Overwrite `window.addEventListener('load')` as they can not be triggered by our script blocker.
 */

function applyWindowLoadInitiator(doc) {
  // Only overwrite once
  if (overwritten) {
    return;
  }

  var defaultView = doc.defaultView;
  var _addEventListener = defaultView.addEventListener;
  Object.assign(defaultView, {
    addEventListener: function addEventListener(type) {
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      if (type === WINDOW_LOAD_EVENT_NAME) {
        // Redirect to own thread to avoid variable order lacks (e. g. Uncode Gmaps Integration)
        setTimeout(function () {
          var _rest$;

          (_rest$ = rest[0]) === null || _rest$ === void 0 ? void 0 : _rest$.call(rest, new Event(WINDOW_LOAD_EVENT_NAME, {
            bubbles: true,
            cancelable: true
          }));
        }, 0);
      } else {
        _addEventListener.apply(this, [type].concat(rest));
      }
    }
  });
  overwritten = true;
}

export { applyWindowLoadInitiator };